import poi from "./poi";
import group from "./group";
import route from "./route";
import event from "./event";
import { createListingModule } from "./listing";

// Code catalog of implemented modules, keyed to match `topic.key` in the
// database. Which of these are shown, in what order and with what label is
// configured in the `topic`/`topic_i18n` tables (see api.topic()) — this
// registry only supplies the actual behavior (a self-contained Panel that
// loads its own data, see ModuleContext.js), which can't live in the
// database.
//
// Adding a module: create modules/<key>/index.js exporting
// { fallbackLabel, Panel }, register it here, and add a `topic` row.
export const modules = {
  poi,
  group,
  route,
  event,
  gastro: createListingModule("gastro", "Gastronomie"),
  stay: createListingModule("stay", "Ferienhäuser"),
};
